import { CommonError } from '../../types';
import {
    FETCH_CANCEL_ORDER_FAILURE,
    FETCH_CANCEL_ORDER_REQUEST,
    FETCH_CANCEL_ORDER_SUCCESS,
    FETCH_MATCH_DATA_FAILURE,
    FETCH_MATCH_DATA_REQUEST,
    FETCH_MATCH_DATA_SUCCESS,
    FETCH_OPEN_ORDER_FAILURE,
    FETCH_OPEN_ORDER_REQUEST,
    FETCH_OPEN_ORDER_SUCCESS,
    FETCH_ORDER_FAILURE,
    FETCH_ORDER_REQUEST,
    FETCH_ORDER_SUCCESS,
    FETCH_UPDATE_ORDER_FAILURE,
    FETCH_UPDATE_ORDER_REQUEST,
    FETCH_UPDATE_ORDER_SUCCESS,
} from './constants';
import { MatchData, OpenOrderData } from './types';

export interface FetchOpenOrderRequestAction {
    type: typeof FETCH_OPEN_ORDER_REQUEST;
    payload: string;
}

export interface FetchOpenOrderSuccessAction {
    type: typeof FETCH_OPEN_ORDER_SUCCESS;
    payload: OpenOrderData[];
}

export interface FetchOpenOrderFailureAction {
    type: typeof FETCH_OPEN_ORDER_FAILURE;
    payload: CommonError;
}
interface CancelOrderPayload {
    id: string;
    ticker: string;
}

export interface OrderPayload {
    ticker: string;
    type: string;
    side: string;
    totalAmount: number;
    price?: number;
}
export interface FetchCancelOrderRequestAction {
    type: typeof FETCH_CANCEL_ORDER_REQUEST;
    payload: CancelOrderPayload;
}

export interface FetchCancelOrderSuccessAction {
    type: typeof FETCH_CANCEL_ORDER_SUCCESS;
}

export interface FetchCancelOrderFailureAction {
    type: typeof FETCH_CANCEL_ORDER_FAILURE;
    payload: CommonError;
}


interface UpdatelOrderPayload {
    orderId: string;
    orderInfo: OrderPayload;
}

export interface FetchUpdateOrderRequestAction {
    type: typeof FETCH_UPDATE_ORDER_REQUEST;
    payload: UpdatelOrderPayload;
}
export interface FetchUpdateOrderSuccessAction {
    type: typeof FETCH_UPDATE_ORDER_SUCCESS;
}
export interface FetchUpdateOrderFailureAction {
    type: typeof FETCH_UPDATE_ORDER_FAILURE;
    payload: CommonError;
}
export interface FetchMatchDataRequestAction {
    type: typeof FETCH_MATCH_DATA_REQUEST;
    payload: string;
}

export interface FetchMatchDataSuccessAction {
    type: typeof FETCH_MATCH_DATA_SUCCESS;
    payload: MatchData[];
}

export interface FetchMatchDataFailureAction {
    type: typeof FETCH_MATCH_DATA_FAILURE;
    payload: CommonError;
}

export interface FetchOrderRequestAction {
    type: typeof FETCH_ORDER_REQUEST;
    payload: OrderPayload;
}

export interface FetchOrderSuccessAction {
    type: typeof FETCH_ORDER_SUCCESS;
}

export interface FetchOrderFailureAction {
    type: typeof FETCH_ORDER_FAILURE;
    payload: any;
}

export type OpenOrderActions =
    | FetchOpenOrderRequestAction
    | FetchOpenOrderSuccessAction
    | FetchOpenOrderFailureAction
    | FetchCancelOrderRequestAction
    | FetchCancelOrderSuccessAction
    | FetchCancelOrderFailureAction
    | FetchMatchDataRequestAction
    | FetchMatchDataSuccessAction
    | FetchMatchDataFailureAction
    | FetchOrderRequestAction
    | FetchOrderSuccessAction
    | FetchOrderFailureAction
    | FetchUpdateOrderRequestAction
    | FetchUpdateOrderSuccessAction
    | FetchUpdateOrderFailureAction;


export const fetchUpdateOrderRequest = (payload: UpdatelOrderPayload): FetchUpdateOrderRequestAction => ({
    type: FETCH_UPDATE_ORDER_REQUEST,
    payload,
});
export const fetchUpdateOrderSuccess = (): FetchUpdateOrderSuccessAction => ({
    type: FETCH_UPDATE_ORDER_SUCCESS,
});
export const fetchUpdateOrderFailure = (error: CommonError): FetchUpdateOrderFailureAction => ({
    type: FETCH_UPDATE_ORDER_FAILURE,
    payload: error,
});

export const fetchOpenOrderRequest = (payload: string): FetchOpenOrderRequestAction => ({
    type: FETCH_OPEN_ORDER_REQUEST,
    payload,
});

export const fetchOpenOrderSuccess = (OpenOrderDatas: OpenOrderData[]): FetchOpenOrderSuccessAction => ({
    type: FETCH_OPEN_ORDER_SUCCESS,
    payload: OpenOrderDatas,
});

export const fetchOpenOrderFailure = (error: CommonError): FetchOpenOrderFailureAction => ({
    type: FETCH_OPEN_ORDER_FAILURE,
    payload: error,
});

export const fetchCancelOrderRequest = (payload: CancelOrderPayload): FetchCancelOrderRequestAction => ({
    type: FETCH_CANCEL_ORDER_REQUEST,
    payload,
});

export const fetchCancelOrderSuccess = (): FetchCancelOrderSuccessAction => ({
    type: FETCH_CANCEL_ORDER_SUCCESS,
});

export const fetchCancelOrderFailure = (error: CommonError): FetchCancelOrderFailureAction => ({
    type: FETCH_CANCEL_ORDER_FAILURE,
    payload: error,
});

export const fetchMatchDataRequest = (payload: string): FetchMatchDataRequestAction => ({
    type: FETCH_MATCH_DATA_REQUEST,
    payload,
});

export const fetchMatchDataSuccess = (matchDatas: MatchData[]): FetchMatchDataSuccessAction => ({
    type: FETCH_MATCH_DATA_SUCCESS,
    payload: matchDatas,
});

export const fetchMatchDataFailure = (error: CommonError): FetchMatchDataFailureAction => ({
    type: FETCH_MATCH_DATA_FAILURE,
    payload: error,
});

export const fetchOrderRequest = (payload: OrderPayload): FetchOrderRequestAction => ({
    type: FETCH_ORDER_REQUEST,
    payload,
});

export const fetchOrderSuccess = (): FetchOrderSuccessAction => ({
    type: FETCH_ORDER_SUCCESS,
});

export const fetchOrderFailure = (error: CommonError): FetchOrderFailureAction => ({
    type: FETCH_ORDER_FAILURE,
    payload: error,
});
